import React from 'react';
import './SessionExpired.css';

const SessionExpired = () => {
  const handleLoginRedirect = () => {
    // Redirect to login page
    window.location.href = '/';
  };

  return (
    <div className="session-expired-container">
      <h1>Session Expired</h1>
      <p>Your session has expired. Please log in again to continue.</p>
      <button onClick={handleLoginRedirect} className="login-button">
        Go to Login
      </button>
    </div>
  );
};

export default SessionExpired;